import * as ReselectModule from "reselect";
import { ILogListState } from ".";
import { IApplicationState } from "..";

export const selectLogList: ReselectModule.Selector<
  IApplicationState,
  ILogListState
> = (state) => state.logList;
